import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { AppConfigService } from "../app.config.service";
import { ApiService } from "./api.service";
import { BaseApiService } from "./base-api.service";

@Injectable({ providedIn: "root" })
export class LogService extends BaseApiService {
	constructor(
		private api: ApiService,
		appConfigService: AppConfigService
	) {
		super("mpapi/log", appConfigService.getConfigValue("API_ENDPOINT"));
	}

	log(level: string, message: string): Observable<void> {
		return this.api.postAndIgnoreError(this.url(), { level, message });
	}
}
